import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class SolutionMasterQueryService {
  public GET_CLIENT_REPORT_BASED_ON_ORDERID: any;

  constructor(public apollo: Apollo) {
    //Get client reports from report master file
    this.GET_CLIENT_REPORT_BASED_ON_ORDERID =
      gql`     
            query getReportSolutionMasters($orderId:Int!){                           
              allReportSolutionMasters(condition:{orderId:$orderId},orderBy:REVIEW_ID_ASC) {
              
                  nodes {
                    acceptStatus
                    reportReviewDetailByReviewId {
                      totalCost    
                      description            
                      categoryName
                      subCategoryName
                      orderId
                      solution
                      insReportId
                    }
                  }
                
              } 
          }
        `;
  }
  GET_ACCEPTED_REPORTS(orderId: number): any {
    return this.apollo
      .watchQuery({
        query: this.GET_CLIENT_REPORT_BASED_ON_ORDERID
        ,
        variables:
        {
          "orderId": orderId,
        },
        fetchPolicy: 'network-only'
      });
  }
}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/reportSolutionMaster.ts